export default "__VITE_ASSET__24SWHy0f__"